// apiConfig.js
const apiConfig = {
    apiUrl: 'https://api.noselfiee.com',
  };
  
  export default apiConfig;
  